/**
 * Inline badge displaying a severity level with color coding.
 * Used in finding lists, detail views, and dashboard summaries.
 */

import { severityBgColor, severityLabel } from '@/utils/formatters';
import type { Severity } from '@/types/finding';

interface SeverityBadgeProps {
  severity: Severity;
}

export default function SeverityBadge({ severity }: SeverityBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${severityBgColor(severity)}`}
    >
      {severityLabel(severity)}
    </span>
  );
}
